export default __webpack_public_path__ + "static/media/error404.7f3bcd3d.svg";